import React, { useRef, useEffect, useState } from "react";
import Sidebar from "../../../components/AdminComponents/SideNav";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav";
import {
  ClientMenu,
  SecondaryNavModule,
} from "../../../components/AdminComponents/MenuItems";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Button, Form, Input, Select, Space, Spin, Image } from "antd";
import { Upload } from "antd";
import {
  UploadOutlined,
  BackwardOutlined,
  FormOutlined,
} from "@ant-design/icons";
import moment from "moment";
import Axios from "../../../api/Axios";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import axios from "axios";
import { getUpdateStatus1 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";
const ModuleDetails = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const formRef = useRef();
  const { id } = useParams();
  const [data, setData] = useState();
  const [logoUrl, setLogoUrl] = useState();
  const [loading, setLoading] = useState(true);
  const [fileName, setFileName] = useState("");
  const ModuleData = useSelector((state) => state.moduleData);
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus1(userInfo, 1, 0);
  const record = ModuleData.find((record) => record.key === id);
  //console.log(record);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const { Option } = Select;
  const onFinish = async (values) => {
    //console.log("Received values of form: ", values);
    //console.log("Received values of form: ", values);
    values.updated_at = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const normalizedValues = Object.fromEntries(
      Object.entries(values).map(([key, value]) => [
        key,
        value === undefined ? null : value,
      ])
    );
    //console.log(normalizedValues);
    if (fileName !== "") {
      normalizedValues.logo = fileName;
    } else {
      normalizedValues.logo = data?.logo;
    }
    try {
      await Axios.put(`/application/${parseInt(id)}/`, normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      UpdateSuccessfull();
    } catch (err) {
      //console.log(err);
      UpdateFailed();
    }
  };
  const UpdateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Details have been updated.",
      duration: 5,
    });
  };

  const UpdateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Details have not been updated.",
      duration: 5,
    });
  };
  const history = useNavigate();
  const handleReset = () => {
    formRef.current.resetFields();
  };
  const LoadUser = async () => {
    try {
      const res = await Axios.get(`/application/${id}/`);
      setData(res.data);
      setLoading(false);
      //console.log(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!loading && formRef.current) {
      formRef.current.setFieldsValue({
        app_id: data.app_id,
        name: data.name,
        type: data.type,
        category: data.category,
        status: data.status,
        // logo: data.logo,
      });
      setLogoUrl(data.logo);
    }
  }, [loading, data]);
  const uploadImage = async (data) => {
    //console.log(data);

    //console.log(data.file.name);
    const payload = {
      filename: data.file.name,
      type: "application",
    };
    try {
      const response = await Axios.post("/uploadurl/", payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(response);
      const file_name = response.data.filename;
      const url = response.data.url;
      //console.log(file_name, url);

      try {
        const res = await axios.put(url, data.file);
        //console.log(res);
        if (res.status === 200) {
          data.onSuccess();
          setFileName(file_name);
        } else {
          data.onError();
        }
      } catch {
        data.onError();
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
  const handleRemove = () => {
    setFileName("");
  };

  return (
    <div>
      <Sidebar props={ClientMenu}>
        {contextHolder}
        <Spin spinning={loading}>
          <SecondaryNav id={parseInt(id)} menuItems={SecondaryNavModule} />
          <div className="form-container">
            <Form
              name="complex-form"
              onFinish={onFinish}
              layout="vertical"
              ref={formRef}
              initialValues={record}
              labelCol={{
                span: 14,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                Width: "100%",
              }}
              disabled={!updateAuth}
            >
              <div className="group1">
                <div className="form-heading">
                  {capitalizeWords("EDIT MODULE")}
                </div>
                <div className="group-1-box">
                  <div style={{ display: "inline-block" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Module ID</p>}
                    >
                      <Space>
                        <Form.Item
                          name="app_id"
                          noStyle
                          rules={[
                            { required: true, message: "ID is required" },
                            {
                              pattern: /^[a-zA-Z0-9]*$/,
                              message:
                                "Please enter alphanumeric characters only",
                            },
                          ]}
                        >
                          <Input
                            className="my-form-input"
                            placeholder={
                              //   errors.username
                              //     ? `${errors.username}`
                              //     :
                              "Enter Module ID"
                            }
                          />
                        </Form.Item>
                      </Space>
                    </Form.Item>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Module Name</p>}
                    >
                      <Space>
                        <Form.Item
                          name="name"
                          noStyle
                          rules={[
                            { required: true, message: "name is required" },
                          ]}
                        >
                          <Input
                            className="my-form-input"
                            placeholder="Enter Module name"
                          />
                        </Form.Item>
                      </Space>
                    </Form.Item>
                  </div>
                </div>
                <div className="group-1-box" style={{ paddingTop: "1rem" }}>
                  <div style={{ display: "inline-block" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Module Type</p>}
                    >
                      <Input.Group compact>
                        <Form.Item
                          name="type"
                          noStyle
                          initialValue={"SaaS"}
                          rules={[
                            {
                              required: true,
                              message: "Type is required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Type"
                            className="my-form-input"
                          >
                            <Option value="SaaS">SaaS</Option>
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </div>

                  <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                    <Form.Item label={<p className="my-form-lables">Status</p>}>
                      <Input.Group compact>
                        <Form.Item
                          name="status"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "status is required",
                            },
                          ]}
                          initialValue={true}
                        >
                          <Select
                            placeholder="Select Status"
                            className="my-form-input"
                          >
                            <Option value={true}>Active</Option>
                            <Option value={false}>Unactive</Option>
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </div>
                </div>
                <div className="group-1-box" style={{ paddingTop: "1rem" }}>
                  <div style={{ display: "inline-block" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Category</p>}
                    >
                      <Input.Group compact>
                        <Form.Item
                          name="category"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "type is required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Category"
                            className="my-form-input"
                          >
                            <Option value="TraineryHCM">Trainery HCM</Option>
                            <Option value="TraineryTrak">Trainery Trak</Option>
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Logo Edit</p>}
                    >
                      <Input.Group compact>
                        <Form.Item
                          name="logo"
                          noStyle
                          valuePropName="fileList"
                          getValueFromEvent={(event) => {
                            if (Array.isArray(event)) {
                              return event;
                            }
                            return event && event.fileList;
                          }}
                        >
                          <Upload
                            name="logo"
                            customRequest={uploadImage}
                            listType="picture"
                            className="my-form-input"
                            onRemove={handleRemove}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              className="my-form-input"
                              style={{
                                width: "35rem",
                                marginLeft: "0.5rem",
                                borderRight: "0",
                                borderLeft: "0",
                                border: "0",
                                borderRadius: "0",
                              }}
                            >
                              Upload New
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                    <Form.Item
                      label={
                        <p
                          className="my-form-lables"
                          style={{ width: "20rem" }}
                        >
                          Existing Logo
                        </p>
                      }
                    >
                      <div
                      // style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Image src={logoUrl} width={120} />
                      </div>
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div style={{ display: "inline-block", marginLeft: "5rem" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                    onClick={() => {
                      history("/admin-manager/modules");
                    }}
                    disabled={false}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    // className="my-form-input-end"
                    style={{
                      background: "#f58029",
                      fontWeight: "600",
                    }}
                    className="save-update-btn"
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        </Spin>
      </Sidebar>
    </div>
  );
};

export default ModuleDetails;
